export default __webpack_public_path__ + "static/media/collapse-collapsible.ba060f2d.svg";